<template>
    <div class="leftBox">
        <div class="model1">
            <title-box titleName="基本信息" @click="refVal.contentWindow.MMAPI.returnView()" />
            <div class="content">
                    <div class="listContentItem" v-for="(item,i) in basicInfo" :key="i" >
                        <div>{{i}}</div>
                        <div>{{item}}</div>
                    </div>
            </div>
        </div>
        <div class="model2">
            <title-box :titleName="unitType.name" />
            <div class="combinationContent">
                    <div :class="`combinationContentItem background0`" @click="onClick0"  >
                        {{unitType.data[0]}}
                    </div>
                    <div :class="`combinationContentItem background1`" @click="onClick1"  >
                        {{unitType.data[1]}}
                    </div>
                    <div :class="`combinationContentItem background2`" @click="onClick2"  >
                        {{unitType.data[2]}}
                    </div>
                    <div :class="`combinationContentItem background3`" @click="onClick3"  >
                        {{unitType.data[3]}}
                    </div>
            </div>
        </div>
        <div class="model3">
            <title-box :titleName="powerGeneration.name" />
            <div class="content">
                    <div class="hourStatistics">
                        每小时:1253.21千瓦时
                    </div>
                    <div class="echartStatistics">
                        <div class="echartsBox" v-for="(item,i) in powerGeneration.data" :key="i">
                            <div class="echartsImg">
                            <VueEcharts :option="item.option" autoresize></VueEcharts>
                            </div>
                            <div class="title">{{item.title}}</div>
                        </div>
                    </div>
                    <div class="statistics">
                        <span>发电量占全厂比例:</span>
                        <span>2021年 95%</span>
                        <span>年度 95%</span>
                    </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState,mapActions } from 'pinia'
import TitleBox from '@/components/title/index.vue'
import useStore from '@/store/index.js' 
export default {
    components:{
        TitleBox,
    },
    methods:{
        onClick0(){
            this.$emit('mode1')
        },
        onClick1(){
            this.$emit('mode2')
        },
        onClick2(){
            this.$emit('mode3')
        },
        onClick3(){
            this.$emit('mode4')
        }

    },
    
    computed:{
        ...mapState(useStore,['basicInfo','unitType','powerGeneration'])
    },
    
}
</script>

<style scoped>
.leftBox{
    width: 357px;
    height: 100%;
    padding-left:32px;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    /* position: absolute;
    left: 0; */
    z-index: 10;
}
.title{
    font-size: 22px;
}
.content{
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px 0px;
}

.content .listContentItem{
    width: 100%;
    height: 33px;
    margin: 10px 0px;
    background: url('@/assets/img/list.png') no-repeat;
    padding:0px 10px 0px 42px;
    box-sizing: border-box;
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: default;
}
.combinationContent{
    flex: 1;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-content: space-around;
    justify-content: space-between;
    font-family: Adobe 黑体;
}
.combinationContent .combinationContentItem{
    width: 156px;
    height: 32px;
    background: url('../assets/img/组11-2.png') no-repeat;
     background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: default;
}
.model3 .hourStatistics{
    height: 62px;
    background: url('../assets/img/组14.png') no-repeat;
    background-size: 100% 100%;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Adobe 黑体;

}
.model3 .statistics{
    width: 100%;
    height: 41px;
    background: url('../assets/img/组163.png') no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 12px;
}
.model3 .statistics >span:nth-child(n+2){
    color: #00fff9;
}
.model3 .echartStatistics{
    width: 100%;
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    align-content: space-around;
    justify-content: space-between;
}
.echartStatistics .echartsBox{
    width: 140px;
    height: 140px;
    margin: 5px 0px;
    display: flex;
    flex-direction: column;
}
.echartStatistics .echartsBox .echartsImg{
    width: 100%;
    flex: 1;
}
.echartStatistics .echartsBox .title{
    width: 100%;
    height: 18px;
    font-size: 14px;
    text-align: center;
    font-family: Adobe 黑体;
    margin-top: 5px;
}
.combinationContentItem.background0:hover,
.combinationContentItem.background1:hover{
    background: url('../assets/img/组11-5.png') no-repeat;
    background-size: 100% 100%;
}
.combinationContentItem.background2{
    background: url('../assets/img/组11-3.png') no-repeat;
    background-size: 100% 100%;
}
.combinationContentItem.background3{
    background: url('../assets/img/组11-3.png') no-repeat;
    background-size: 100% 100%;
}
.combinationContentItem.background2:hover,
.combinationContentItem.background3:hover{
    background: url('../assets/img/组11-5.png') no-repeat;
    background-size: 100% 100%;
}
.model1{
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
}
.model2{
    flex: .5;
    width: 100%;
    display: flex;
    flex-direction: column;
}
.model3{
    flex: 1.5;
    width: 100%;
    display: flex;
    flex-direction: column;
}
</style>